export enum UserListSaveModalResponse {
  CREATE_SUCCESS,
}
